// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"db69e0fc","152":"136d5419","440":"79b75515","464":"ab9e651f","592":"dec2c3ec","608":"38d0828e","848":"f227b4a6","944":"3a2352d2"}[chunkId] + ".chunk.js";
};